<template>
  <v-dialog v-model="model" fullscreen>
    <v-card>
      <v-card-title style="display: flex; justify-content: space-between">
        {{ $t("report") }} {{ toLatin(employee.name) }} {{ toLatin(employee.lastname) }}
        <circle-button
          @click="model = false"
          icon="mdi-close"
          :disabled="loading"
        ></circle-button>
      </v-card-title>
      <v-card-text>
        <!-- Loading State -->
        <empty-state
          v-if="loading"
          :title="$t('loading_employee_report')"
          :loading="true"
        />

        <!-- Error State -->
        <empty-state
          v-else-if="error"
          icon="mdi-alert-circle"
          :title="$t('error_loading_report')"
        >
          <v-btn color="primary" outlined @click="getEmployeeReport()">
            {{ $t("retry") }}
          </v-btn>
        </empty-state>

        <!-- Content State -->
        <v-simple-table v-else-if="userReport && userReport.length" dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  {{ $t("date") }}
                </th>
                <th class="text-left">
                  {{ $t("id_order") }}
                </th>
                <th class="text-left">
                  {{ $t("shifts") }}
                </th>
                <th class="text-left">
                  {{ $t("title") }}
                </th>
                <th class="text-left">
                  {{ $t("quantity") }}
                </th>
                <th class="text-left">
                  {{ $t("category") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, index1) in userReport">
                <template v-for="(order, index2) in item.orders">
                  <tr v-for="(food, index3) in order.foods">
                    <td v-if="index3 === 0" :rowspan="order.foods.length">
                      {{ item.date }}
                    </td>
                    <td v-if="index3 === 0" :rowspan="order.foods.length" align="center">
                      {{ food.id }}
                    </td>
                    <td>{{ food.shift }}</td>
                    <td>{{ food.meal_name }}</td>
                    <td>{{ food.quantity }}</td>
                    <td>{{ food.category_name }}</td>
                  </tr>
                </template>
              </template>

              <tr>
                <td class="font-weight-bold">Ukupno</td>
                <td align="center" class="font-weight-bold">
                  {{ userReport.length }}
                </td>
                <td colspan="2"></td>
                <td class="font-weight-bold">
                  {{ foodTotal }}
                </td>
                <td></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <!-- Empty State -->
        <empty-state
          v-else
          icon="mdi-clipboard-text-off"
          :title="$t('no_employee_report_data')"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasSnackbar from "@/mixins/hasSnackbar";
import userService from "@/services/user";
import EmptyState from "@/components/global/EmptyState.vue";

export default {
  mixins: [hasModel, hasSnackbar],
  components: {
    EmptyState,
  },
  props: {
    employee: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    userReportPlane: [],
    userReport: [],
    loading: false,
    error: false,
  }),
  computed: {
    foodTotal() {
      return this.userReportPlane.reduce((sum, item) => {
        return sum + item.quantity;
      }, 0);
    },
    dates() {
      return this.$store.state.report.filters.dates;
    },
  },
  methods: {
    getEmployeeReport() {
      if (!this.employee?.id) return;

      this.loading = true;
      this.error = false;
      this.userReport = [];
      this.userReportPlane = [];

      userService
        .getFoodOrdersByMonth({
          month: this.dates.from.slice(5, 7),
          year: this.dates.from.slice(0, 4),
          date_from: this.dates.from,
          date_to: this.dates.to,
          user_id: this.employee.id,
        })
        .then((res) => {
          let orders = [];
          res.data.forEach((orderItem) => {
            let findDate = orders.find((i) => i.date === orderItem.date);

            if (findDate) {
              let findOrder = findDate.orders.find((i) => i.id === orderItem.id);
              if (findOrder) {
                findOrder.foods = [...findOrder.foods, orderItem];
              } else {
                findDate.orders.push({
                  id: orderItem.id,
                  foods: [orderItem],
                });
              }
            } else {
              orders.push({
                date: orderItem.date,
                orders: [
                  {
                    id: orderItem.id,
                    foods: [orderItem],
                  },
                ],
              });
            }
          });
          this.userReport = orders;
          this.userReportPlane = orders.flatMap((item) => {
            return item.orders.flatMap((order) => {
              return order.foods.map((food) => ({
                date: item.date,
                id: order.id,
                shift: food.shift,
                meal_name: food.meal_name,
                quantity: food.quantity,
                category_name: food.category_name,
              }));
            });
          });
        })
        .catch((error) => {
          console.error("Error loading employee report:", error);
          this.error = true;
          this.showErrorSnackbar(this.$t("error_loading_employee_report"));
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    employee: {
      handler() {
        if (this.employee.id) {
          this.getEmployeeReport();
        }
      },
      deep: true,
    },
    dates: {
      handler() {
        this.getEmployeeReport();
      },
      deep: true,
    },
  },
};
</script>
